/**
 * 职位申请管理相关API接口
 */
import axios from '../axios'

const jobApplicationAPI = {
  // 获取职位申请列表
  getJobApplications(params) {
    return axios({
      url: '/jobApplications/list',
      method: 'GET',
      params
    })
  },
  
  // 获取单个职位申请详情
  getJobApplication(id) {
    return axios({
      url: `/jobApplications/${id}`,
      method: 'GET'
    })
  },
  
  // 更新职位申请状态
  updateJobApplicationStatus(id, status) {
    return axios({
      url: `/jobApplications/${id}`,
      method: 'PUT',
      data: { status }
    })
  },
  
  // 更新职位申请已读状态
  updateJobApplicationReadStatus(id, read) {
    return axios({
      url: `/jobApplications/${id}`,
      method: 'PUT',
      data: { read }
    })
  },
  
  // 删除职位申请
  deleteJobApplication(id) {
    return axios({
      url: `/jobApplications/${id}`,
      method: 'DELETE'
    })
  }
}

export default jobApplicationAPI